import { Carousel } from '@peracto/peracto-blocks-tailwind'
import Accordion from './Accordion'
import Buttons from './Buttons'
import Container from './Container'
import Products from './Products'

export default {
    plugins: {
        content: [Buttons, Carousel, Accordion, Products],
        layout: [Container],
    },
}
